import loadable from '@wix/yoshi-flow-editor/loadable';

export const CustomTabPage = loadable(
  () => import(/* webpackChunkName: "CustomTabPage" */ './CustomTabPage'),
  {
    resolveComponent: (component) => component.CustomTabPage,
  },
);
